module.exports = __webpack_public_path__ + "img/3.f808b472.png";